import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enComponentLocales from "./en";
import frComponentLocales from "./fr";
import arComponentLocales from "./ar";
import cnComponentLocales from "./cn";

const i18nForComponent = i18n.createInstance();

i18nForComponent
  .use(initReactI18next)
  .init({
    resources: {
      en: { translations: enComponentLocales },
      fr: { translations: frComponentLocales },
      cn: { translations: cnComponentLocales },
      ar: { translations: arComponentLocales },
    },
    lng: "en",
    fallbackLng: "en",
    debug: false,
    ns: ["translations"],
    defaultNS: "translations",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18nForComponent;
